export const prependProtocolToUrl = (inputUrl: string) => {
    // eslint-disable-next-line no-script-url
    if (inputUrl.startsWith("javascript:") || inputUrl.startsWith("data:")) {
        return "-- URL deactivated due to security concerns ---";
    }

    const protolRegex = new RegExp(`^[a-z]{1,100}://`);
    return protolRegex.test(inputUrl) ? inputUrl : `http://${inputUrl}`;
};
